<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/rewards'"></fgb-page-header>

<div *ngIf="lottoItem; else noPurchase">
  <div class="d-block d-lg-flex border-0 rounded overflow-hidden justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3 pt-lg-4 pt-0">
      <div class="d-lg-flex d-block">
        <div class="redemption-container">
          <div class="text-primary mb-0 fw-bold font-size-18 text-left">
            {{ 'lotto.entry.successful' | translate }}
          </div>
          <p class="mb-0 font-size-14 text-left pe-lg-4 rewards-success-description w-100">
            <ng-container>{{ 'lottos.purchase.confirm' | translate }}</ng-container>
          </p>
          <div class="back-wallet-button back-wallet-button d-flex justify-content-between border-0">
            <a class="btn btn-primary confirm-btn fw-bold text-white" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>
        <div class="payment-details">
          <div class="d-lg-flex d-block">
            <img
              class="purchase-success-image rounded"
              src="{{ lottoItem.ImageName | contentImage: '6' : 'lotto' }}"
              alt="{{ lottoItem.ImageName }}"
              [useDefault]="true"
              [loyaltyType]="'lotto'"
              draggable="false"
            />
            <div class="">
              <!--Name-->
              <div class="font-size-14 mb-3 fw-bold text-primary">{{ lottoItem.Title }}</div>
              <!-- Custom Fields -->
              @if (customFields.length > 0) {
                @for (field of customFields; track field.customFieldId) {
                  <div class="d-flex align-items-center mt-2">
                    <span class="font-size-12 lotto-details-spacing">{{ field.customFieldName }}</span>
                    @switch (field.customValidationType) {
                      @case (customValidationType.Date) {
                        <span class="fw-bold font-size-14">{{
                          field.customFieldValue | UtcToLocaltimePipe: dateOptions.NgbDateFormat
                        }}</span>
                      }
                      @default {
                        <span class="fw-bold font-size-14">{{ field.customFieldValue }}</span>
                      }
                    }
                  </div>
                }
              }
              <!--Quantity-->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 lotto-details-spacing">{{ 'lotto.entries' | translate }}</span>
                <span class="fw-bold font-size-14">{{ quantity | number }}</span>
              </div>

              <!--Price-->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 lotto-details-spacing">{{ 'marketplace.points.used' | translate }}</span>
                <span *ngIf="totalPrice > 0" class="fw-bold font-size-14 text-primary"
                  >{{ totalPrice | number }} {{ 'fgbcl.currency.pts' | translate }}</span
                >
                <span *ngIf="totalPrice == 0" class="fw-bold font-size-14 text-primary">
                  {{ 'fgbcl.marketplace.item.free' | translate }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noPurchase>
  <div class="text-center m-5">{{ 'no.purchased.item.found' | translate }}</div>
</ng-template>
